export const DisplayArticlesValues = (t) => ([
	{ value: 0, label: t('options_section.strings.regular') },
	{ value: 1, label: t('options_section.strings.bigger') }
])
